import * as Sentry from '@sentry/browser';
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';

import makeApiRequest from '../../utils/makeApiRequest';
import makePrivateApiRequest from '../../utils/makePrivateApiRequest';

import { API_ENDPOINTS, PRIVATE_API_ENDPOINTS } from '../../constants';
import Button from './Button';
import Header from './Header';

const StepBegin = ({ onFetchedOrder, activationCode, steps, setStatus }) => {
  const [isLoading, setIsLoading] = useState(!!activationCode);
  const [showError, setShowError] = useState(false);

  // Imidiately submit activation code if it's provided
  useEffect(() => {
    if (activationCode) {
      handleSubmit(activationCode);
    }
  }, []);

  // Submit the activation code form
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowError(false);

    const formDate = new FormData(e.target);
    const orderId = formDate.get('order');
    handleSubmit(orderId);
  };

  const handleSubmit = async (code) => {
    try {
      // Fetch activation status
      const data = await makeApiRequest(API_ENDPOINTS.ACTIVATION_BEGIN, { activationCode: code });

      // Fetch order activation rules
      const rules = await makePrivateApiRequest(PRIVATE_API_ENDPOINTS.ACTIVATION_RULES, { code });

      console.log(rules);
      console.log(data);

      // Find the next step
      let nextStep;
      if (data.nextStep) {
        nextStep = data.nextStep;
      } else if (data.currentStep) {
        nextStep = data.currentStep;
      } else {
        const finishedStess = data.Steps.sort((a, b) => b.StepOrder - a.StepOrder);
        nextStep = finishedStess.find((step) => step.StepJson?.nextStep)?.StepJson.nextStep;
      }

      // Fix transfer step
      if (nextStep === steps.NUMBER_TRANSFER) {
        nextStep = steps.NUMBER_TRANSFER_STARTED;
      }

      // Check if new number is activated
      if (data.Steps?.some((step) => step.StepName === 'New' && step.StepJson?.ProvSyncTime)) {
        setStatus((current) => ({ ...current, provisioned: true }));
      }

      const results = {
        customerId: data.CustomerId ? data.CustomerId : data.Steps[0].CustomerID,
        orderId: code,
        nextStep,
        rules,
      };

      console.log(results);

      onFetchedOrder(results);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      setIsLoading(false);
      setShowError(true);
    }
  };

  return html`
    <${Header}
      title="Let's Activate Your Plan"
      description="Start by entering your activation code. You can find your it in the confirmation email."
      eyebrow="Takes Only 2 Minutes"
    />
    <form class="flex flex-col gap-3 items-stretch max-w-96 w-full" onSubmit=${handleFormSubmit}>
      <input
        type="text"
        class="grow min-w-0 px-5 py-5 rounded-xl text-base lg:text-sm focus:outline-none text-center"
        name="order"
        placeholder="Enter your activation code"
        aria-label="Order Number"
        autocomplete="off"
        required
      />
      <${Button} text="Get Started" loading=${isLoading} />
      ${showError &&
      html`<p class="text-red-500 text-center text-sm">We couldn't find your order. Please try again.</p>`}
    </form>
  `;
};

export default StepBegin;
